/**
 * Constants & Configuration
 * All constants, search copy templates, selectors, CSS classes
 */

// Search copy templates for zero-results and fallback messages
export const SEARCH_COPY = {
  normalizedMismatchHeader: `We couldn't find camps for "{rawInput}".`,
  normalizedMismatchSubtext: `Below are camps in <span>{locationLabel}</span> that match your search.`,
  normalizedZeroHeader: `No camps available in <span>{locationLabel}</span>.`,
  normalizedZeroSubtext: `Below are camps in <span>{stateCode}</span> that match your search.`,
  unrecognizedHeader: `We couldn't recognize "<span>{rawInput}</span>" as a location.`,
  unrecognizedSubtextUser: `Below are camps in <span>{locationLabel}</span> that match your search.`,
  unrecognizedSubtextGlobal: `Below are camps across all our locations that match your search.`,
  datesZeroHeader: `No camps available on these dates.`,
  datesZeroSubtext: `Below are camps with <span>nearby start dates</span>.`,
  datesLocationZeroHeader: `No camps available in <span>{locationLabel}</span> on these dates.`,
  datesLocationZeroSubtext: `Below are camps in <span>{locationLabel}</span> with <span>nearby start dates</span>.`,
  datesLocationStateSubtext: `Below are camps in <span>{stateCode}</span> that match your search.`,
  datesLocationGlobalSubtext: `Below are camps across all our locations that match your search.`,
};

// LocalStorage key for search state persistence
export const STATE_STORAGE_KEY = "campsSearchState_v2";

// Hash seeds for tier values (precomputed constants)
export const TIER_SEEDS = [0x1a2b3c4d, 0x5e6f7a8b, 0x9c0d1e2f, 0x3f4a5b6c];

// UK constituent countries for UK-wide search filter
export const UK_COUNTRIES = ["England", "Scotland", "Wales", "Northern Ireland"];

// European countries list for "Europe" search filter
export const EUROPEAN_COUNTRIES = [
  "England",
  "Scotland",
  "Wales",
  "Northern Ireland",
  "Ireland",
  "IE",
  "France",
  "FR",
  "Germany",
  "DE",
  "Spain",
  "ES",
  "Italy",
  "IT",
  "Netherlands",
  "NL",
  "Belgium",
  "BE",
  "Switzerland",
  "CH",
  "Austria",
  "AT",
  "Portugal",
  "PT",
  "Greece",
  "GR",
  "Denmark",
  "DK",
  "Sweden",
  "SE",
  "Norway",
  "NO",
  "Finland",
  "FI",
  "Poland",
  "PL",
  "Czech Republic",
  "CZ",
  "Hungary",
  "HU",
  "Romania",
  "RO",
  "Bulgaria",
  "BG",
  "Croatia",
  "HR",
  "Slovakia",
  "SK",
  "Slovenia",
  "SI",
  "Luxembourg",
  "LU",
  "Malta",
  "MT",
  "Cyprus",
  "CY",
  "Estonia",
  "EE",
  "Latvia",
  "LV",
  "Lithuania",
  "LT",
  "Iceland",
  "IS",
];

// DOM selectors
export const SELECTORS = {
  zipInput: "#zip-search",
  mobileZipInput: "#mobile-search-field",
  liveCheckbox: "#live-camps",
  sportFilters: "#sport-filters",
  typeFilters: "#type-filters",
  genderFilters: "#gender-filters",
  brandFilters: "#brand-filters",
  ageInput: "#age-input",
  sortSelect: "#camp-sort",
  typeFilterSelect: "#type-filter",
  resultsContainer: "#search-results",
  resultsHeading: "#results-heading",
  resultsSubheading: "#results-subheading",
  resultsCount: "#results-count",
  activeFilters: "#active-filters",
  pagination: "#pagination",
  noResults: "#no-results",
  fallbackBanner: "#fallback-banner",
  fallbackTitle: "#fallback-title",
  fallbackText: "#fallback-text",
  sportItem: ".rd-search-modal__sport-item",
  filterPanel: "#filter-panel",
  mobileFilterToggle: "#mobile-filter-toggle",
  closeFilters: "#close-filters",
  saveFilters: "#save-filters",
  resetFilters: "#reset-filters",
  resetFiltersDesktop: "#reset-filters-desktop",
  filtersCount: ".rd-search-results__show-filters-count",
  sidebarFiltersCounts: ".rd-search-results__filters-count",
};

// CSS classes
export const CLASSES = {
  loading: "is-loading",
  selected: "rd-search-modal__sport-item--selected",
  hasValue: "rd-search-form__choise-text--has-value",
  open: "is-open",
  hidden: "is-hidden",
  active: "is-active",
};

console.log("📦 Constants module loaded");
